module.exports = __webpack_public_path__ + "static/img/backimg.17cddaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/backimg.jpg
// module id = PwXh
// module chunks = 15